<div class="free-plan-registration" data-testid="free-plan-registration-content">
  @if (hasError()) {
  <div
    class="free-plan-registration__progress free-plan-registration__progress--error"
    data-testid="free-plan-registration-error"
    role="alert"
  >
    <mat-icon>error_outline</mat-icon>
    <p>Something went wrong. Please try again.</p>
  </div>
  } @else if (isCreating()) {
  <div class="free-plan-registration__progress" data-testid="free-plan-registration-progress" role="status">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Creating your Free plan and Saving your new Wheel</p>
  </div>
  }

  <div [class.free-plan-registration__form-content--hidden]="hasError() || isCreating()" class="free-plan-registration__form-content">
    <p class="free-plan-registration__subheading" data-testid="free-plan-registration-subheading">{{ subheading() }}</p>

    <wil-complete-signup-form
      [hideSecondNameAndConfirmPassword]="true"
      [navigateAfterRegistration]="false"
      (registrationStarted)="onRegistrationStarted()"
      (registrationSucceeded)="onRegistrationSucceeded()"
      data-testid="free-plan-registration-form"
    ></wil-complete-signup-form>

    <div class="free-plan-registration__footer">
      <span>Registered already?</span>
      <button
        type="button"
        class="free-plan-registration__link"
        (click)="navigateToLogin.emit()"
        data-testid="free-plan-registration-login-link"
      >
        Log in
      </button>
    </div>
  </div>
</div>
